module.exports = __webpack_public_path__ + "img/404.edbd6558.png";